import { keyframes } from "styled-components";

export const bounceAnimation = (offset, unit = 'rem') => {
  return keyframes`
      0%   { transform: translateY(0); }
      50%  { transform: translateY(${offset + unit}); }
      100% { transform: translateY(0); }
    `
}

export const moveElementHorizontally = ({ x1, x2, unit = 'rem' }) => {
  return keyframes`
      0% {transform: translateX(${(x1 + unit)} ); }
      100% {transform: translateX(${x2 + unit}); }
    `
}

export const moveElementVertically = ({ y1, y2, unit = 'rem' }) => {
  return keyframes`
      0% {transform: translateY(${(y1 + unit)} ); }
      100% {transform: translateY(${y2 + unit}); }
    `
}

export const upDownAnimation = (y=0) => keyframes`
  50% { 
    transform: translateY(${y}rem);
    opacity: 0.1;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
`

export const scaleEffect = (scaleValue=1) => keyframes`
    0% {
      transform: scale(${scaleValue});
      box-shadow: none;
    }
    100% {
      transform: scale(1);
      box-shadow: 0 0 0 1.6rem rgba(79,82,195,0.3);
    }
`

export const shimmerEffect = ()=> keyframes`
0% {
        background-position: 0 0;
    }
    100% {
        background-position: 100% 0;
    }
`;

